import React, { useState } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axiosInstance from "../../axiosInstance";

function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const validateForm = () => {
    if (!email.trim() || !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setError("Valid email is required.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!validateForm()) {
      return;
    }

    try {
      const response = await axiosInstance.post("/users/forgetPassword", {
        email,
      });

      if (response.data.success) {
        setMessage("Password reset link has been sent to your email.");
      } else {
        setError(response.data.error.message || "Password reset failed!");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
        setError(err.response.data.error.message);
      } else {
        setError("An error occurred during password reset.");
      }
    }
  };

  return (
    <Col md={5} className="p-5 bg-white full-height">
      <div className="login-main-left">
        <div className="text-center mb-5 login-main-left-header pt-4">
          <a href="https://autotrak.ai/">
          <img src="/img/logo-autotrak.png" className="img-fluid" alt="LOGO" />
          </a>
        </div>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <div className="mt-4">
            <Row>
              <Col>
                <Button type="submit" variant="outline-primary" size="lg" block>
                  Reset Password
                </Button>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Link to="/auth/login">
                  <Button variant="outline-primary" size="lg" block>
                    Back To Login
                  </Button>
                </Link>
              </Col>
            </Row>
          </div>

          {error && <p className="text-danger mt-3">{error}</p>}
          {message && <p className="text-success mt-3">{message}</p>}
        </Form>

        <div className="text-center mt-5">
          <p className="light-gray">
            Don't have an account? <Link to="/auth/register">Sign up</Link>
          </p>
        </div>
      </div>
    </Col>
  );
}

export default ForgetPassword;
